import { useState, useEffect, useMemo } from 'react'
import { trackGoal } from 'fathom-client'
import HCaptcha from '@hcaptcha/react-hcaptcha'

import { Textlayout } from 'components/layout'

export default function commentForm({ articleId, inReplyTo, setInReplyTo, comments }) {
  const [commentData, setCommentData] = useState({})
  const [response, setResponse] = useState({ type: '', message: '' })
  const commentWhichIsReplied = useMemo(
    () => (inReplyTo ? comments.find((el) => el.node.databaseId === inReplyTo) : null),
    [inReplyTo]
  )

  const sendComment = (e) => {
    e.preventDefault()

    fetch('/api/postComment', {
      method: 'POST',
      body: JSON.stringify({ ...commentData, replyToCommentWithId: inReplyTo }),
      headers: { 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.error) {
          trackGoal('XE3NNEYW', 0)
          return setResponse({ type: 'error', message: json.error })
        }
        trackGoal('SQNE3TLW', 0)
        setResponse({ type: 'done', message: 'Commentaire envoyé !' })
        return setCommentData({ articleId: articleId, name: '', comment: '', mail: '', token: '', ekey: '' })
      })
  }

  useEffect(() => {
    setCommentData((prev) => ({
      ...prev,
      articleId: articleId
    }))
  }, [articleId])

  return (
    <div className="px-6 py-4 bg-yellow-50 md:px-0">
      <Textlayout>
        <form onSubmit={sendComment}>
          {inReplyTo ? (
            <>
              <h3 className="text-lg">
                Répondre à {commentWhichIsReplied.node.author.node?.name || 'Anonyme'} qui a dit:{' '}
              </h3>
              <p className="italic">{commentWhichIsReplied.node.content}</p>
              <button onClick={() => setInReplyTo('')}>Annuler</button>
            </>
          ) : (
            <h3 className="text-lg">Poster un commentaire</h3>
          )}
          <div className="grid gap-4 grid-cols-1 mt-4 md:grid-cols-2">
            <div>
              <label className="font-serif text-lg" htmlFor="name">
                Nom
              </label>
              <input
                value={commentData.name}
                onChange={(e) => setCommentData((prev) => ({ ...prev, name: e.target.value }))}
                id="name"
                required
                type="text"
                className="focus:ring- w-full bg-transparent border-b border-black rounded-none focus:outline-none focus:ring-black focus:ring-offset-yellow-50 focus:ring-offset-4 focus:ring-1"
              />
            </div>
            <div>
              <label className="font-serif text-lg" htmlFor="mail">
                E-mail
              </label>
              <input
                value={commentData.mail}
                onChange={(e) => setCommentData((prev) => ({ ...prev, mail: e.target.value }))}
                id="mail"
                required
                type="email"
                className="focus:ring- w-full bg-transparent border-b border-black rounded-none focus:outline-none focus:ring-black focus:ring-offset-yellow-50 focus:ring-offset-4 focus:ring-1"
              />
            </div>

            <div className="md:col-span-2">
              <label className="font-serif text-lg" htmlFor="comment">
                Commentaire
              </label>
              <textarea
                value={commentData.comment}
                onChange={(e) => setCommentData((prev) => ({ ...prev, comment: e.target.value }))}
                id="comment"
                required
                rows={parseInt(`${commentData.comment}`.split('\n').length + 2)}
                className="textareaStripe w-full rounded-none focus:outline-none resize-y focus:ring-black focus:ring-offset-yellow-50 focus:ring-offset-4 focus:ring-1"
              />
            </div>
          </div>
          <div className="z-30 flex justify-center mt-4">
            <HCaptcha
              sitekey={process.env.NEXT_PUBLIC_HCAPTCHA_KEY}
              onVerify={(token, ekey) => setCommentData((prev) => ({ ...prev, token, ekey }))}
            />
          </div>{' '}
          {response.type === 'error' && <div>Une erreur est survenue: {response.message}</div>}
          {response.type === 'done' && (
            <div>Votre commentaire a été envoyé. Nous le publierons après vérification.</div>
          )}
          <div className="flex justify-center mt-8 w-full">
            <button
              type="submit"
              className="focus:ring-offser-2 pb-1.5 pt-2.5 px-4 text-lg leading-4 border border-black focus:outline-none uppercase focus:ring-black focus:ring-offset-transparent focus:ring-2">
              Envoyer
            </button>
          </div>
        </form>
      </Textlayout>
    </div>
  )
}
